function hasErrors(fieldsError) {
  return fieldsError
    ? Object.keys(fieldsError).some(field => fieldsError[field])
    : false;
}

const progresses = {};

progresses.default = [
  {
    title: 'Должность',
    name: 'position',
    completed: false,
    fields: ['role'],
    check: (values, form) => {
      return !!(!hasErrors(form.getFieldsError(['role'])) && values.role);
    },
  },
  {
    title: 'Фамилия',
    name: 'lastname',
    completed: false,
    fields: ['lastname'],
    check: (values, form) => {
      return !!(
        !hasErrors(form.getFieldsError(['lastname'])) && values.lastname
      );
    },
  },
  {
    title: 'Имя',
    name: 'name',
    completed: false,
    fields: ['name'],
    check: (values, form) => {
      return !!(!hasErrors(form.getFieldsError(['name'])) && values.name);
    },
  },
  {
    title: 'Отчество',
    name: 'patronymic',
    completed: false,
    fields: ['patronymic'],
    button: false,
  },
  {
    title: 'Дата рождения',
    name: 'birthDate',
    completed: false,
    fields: ['birthDate'],
    check: (values, form) => {
      return !!(
        !hasErrors(form.getFieldsError(['birthDate'])) && values.birthDate
      );
    },
  },
  {
    title: 'Номер телефона',
    name: 'phoneNumber',
    completed: false,
    fields: ['phoneNumber'],
    check: (values, form) => {
      return !!(
        !hasErrors(form.getFieldsError(['phoneNumber'])) && values.phoneNumber
      );
    },
  },
  {
    title: 'E-mail',
    name: 'email',
    completed: false,
    fields: ['email'],
    check: (values, form) => {
      return !!(!hasErrors(form.getFieldsError(['email'])) && values.email);
    },
  },
];

export default progresses;
